// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1kIHP","label":"CategoryService_label__2jdz2","location":"CategoryService_location__2at9V"};